import { Dispatch, SetStateAction } from 'react';
import { Switch } from '@headlessui/react';
import { useUpgradePlanToggle } from '../../../../../lib/store/dashboard.store';

export const SwitchPlan = () => {
  const enabled = useUpgradePlanToggle((state: any) => state.checked);
  const setEnabled = useUpgradePlanToggle((state: any) => state.setChecked);

  return (
    <div className="flex items-center font-montserrat">
      <span
        className={`${
          enabled ? 'text-[#788AA6CC]' : 'text-[#364152]'
        } text-sm capitalize pr-4 font-semibold`}>
        Monthly
      </span>
      <Switch
        checked={enabled}
        onChange={() => {
          setEnabled(!enabled);
        }}
        className={`${enabled ? 'bg-[#2497B2]' : 'bg-[#2497B2] unchecked_toggle--border'} 
        h-[18px] w-[36px]
          relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}>
        <span
          aria-hidden="true"
          className={`${enabled ? 'translate-x-4' : 'translate-x-0'} h-[14px] w-[14.5px]
            pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>

      <span
        className={`${
          enabled ? 'text-[#364152]' : 'text-[#788AA6CC]'
        } text-sm capitalize pl-4 font-semibold`}>
        Annual
      </span>
    </div>
  );
};

//   return (
//     <div className="flex items-center font-montserrat pl-4">
//       <span
//         className={`${
//           !enabled ? 'text-[#364152]' : 'text-[#788AA6B2]'
//         } text-sm capitalize mr-2 font-semibold`}>
//         Annual
//       </span>

//       <Switch
//         checked={enabled}
//         onChange={() => {
//           setEnabled(!enabled);
//         }}
//         className={`${enabled ? 'bg-[#2497B2]' : 'bg-[#2497B2] unchecked_toggle--border'}
//         h-[18px] w-[36px]
//           relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}>
//         <span
//           aria-hidden="true"
//           className={`${enabled ? 'translate-x-4' : 'translate-x-0'} h-[14px] w-[14.5px]
//             pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
//         />
//       </Switch>
//       <span
//         className={`${
//           !enabled ? 'text-[#788AA6B2]' : 'text-[#364152]'
//         } text-sm capitalize ml-2 font-semibold`}>
//         Monthly
//       </span>
//     </div>
//   );
// };
